(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmb-cover-test"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pmb-cover-test')) {
    customElements.define('pmb-cover-test', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.panel = this.querySelector('[data-panel]');
        if (!this.panel) return;
        this.abort = new AbortController();
        this.fields = this.panel.querySelector('[data-fields]');
        this.first = this.panel.querySelector('[data-line-one]');
        this.second = this.panel.querySelector('[data-line-two]');
        this.error = this.panel.querySelector('[data-error]');
        this.reference = this.newReference();
        this.pending = null;
        const options = { signal: this.abort.signal };
        this.panel.addEventListener('input', () => this.sync(), options);
        document.addEventListener('submit', event => this.onSubmit(event), { ...options, capture: true });
        document.addEventListener('cart:update', event => this.onCartUpdate(event), options);
        document.addEventListener('cart:error', event => {
          if (event.target === this.form?.closest('product-form-component')) this.pending = null;
        }, options);
        this.treeObserver = new MutationObserver(records => {
          if (records.every(record => this.panel.contains(record.target))) return;
          this.schedule();
        });
        this.treeObserver.observe(document.body, { childList: true, subtree: true });
        this.mount();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.formAbort?.abort();
        this.widgetAbort?.abort();
        this.treeObserver?.disconnect();
        this.widgetObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.mirrors?.forEach(input => input.remove());
        if (this.panel && !this.contains(this.panel)) this.append(this.panel);
        this.abort = null;
      }

      newReference() {
        const alphabet = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
        const bytes = crypto.getRandomValues(new Uint8Array(12));
        return 'B-' + Array.from(bytes, byte => alphabet[byte % alphabet.length]).join('');
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.mount();
        });
      }

      mount() {
        const component = document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
        const form = component?.querySelector('form[action*="/cart/add"]');
        const host = document.querySelector(`kaching-bundle[product-id="${this.dataset.productId}"]`);
        const widget = host?.querySelector('kaching-bundles-block');
        if (!form || !host || !widget) {
          this.ready = false;
          return;
        }
        if (this.panel.previousElementSibling !== host) host.after(this.panel);
        this.panel.hidden = false;
        if (this.form !== form) {
          this.formAbort?.abort();
          this.mirrors?.forEach(input => input.remove());
          this.form = form;
          this.formAbort = new AbortController();
          this.mirrors = ['Bokreferens', 'Framsida – rad 1', 'Framsida – rad 2'].map(name => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${name}]`;
            form.append(input);
            return input;
          });
          this.first.setAttribute('form', form.id);
          this.second.setAttribute('form', form.id);
          form.addEventListener('formdata', event => {
            this.sync();
            this.mirrors.forEach(input => {
              if (input.disabled) event.formData.delete(input.name);
              else event.formData.set(input.name, input.value);
            });
          }, { signal: this.formAbort.signal });
        }
        if (this.widget !== widget) {
          this.widgetAbort?.abort();
          this.widgetObserver?.disconnect();
          this.widget = widget;
          this.widgetAbort = new AbortController();
          widget.addEventListener('variants-changed', () => this.schedule(), { signal: this.widgetAbort.signal });
          this.widgetObserver = new MutationObserver(() => this.schedule());
          this.widgetObserver.observe(widget, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'href'] });
        }
        this.sync();
      }

      sync() {
        if (!this.widget || !this.form) return;
        const bar = this.widget.querySelector('.kaching-bundles__bar--selected');
        const upsell = Array.from(bar?.querySelectorAll('.kaching-bundles__upsell') || []).find(item => {
          const href = item.querySelector('a[href]')?.getAttribute('href');
          return href && new URL(href, location.origin).searchParams.get('variant') === this.dataset.coverVariant;
        });
        this.ready = Boolean(this.widget.isConnected && this.form.isConnected && bar && upsell);
        const selected = this.ready && Boolean(upsell.querySelector('.kaching-bundles__upsell__checkbox--selected'));
        this.selected = selected;
        if (this.fields.hidden === selected) this.fields.hidden = !selected;
        if (this.fields.disabled === selected) this.fields.disabled = !selected;
        for (const input of [this.first, this.second]) {
          if (input.disabled === selected) input.disabled = !selected;
        }
        this.first.required = selected;
        const label = this.panel.querySelector('[data-reference]');
        if (label.textContent !== this.reference) label.textContent = this.reference;
        const values = [this.reference, this.first.value.trim(), this.second.value.trim()];
        this.mirrors.forEach((input, index) => {
          if (!this.form.contains(input)) this.form.append(input);
          if (input.value !== values[index]) input.value = values[index];
          input.disabled = index > 0 && !selected;
        });
        if (this.ready) this.error.hidden = true;
      }

      onSubmit(event) {
        const component = event.target.closest?.('product-form-component');
        if (component?.dataset.productId !== this.dataset.productId) return;
        this.mount();
        if (event.target !== this.form || !this.ready) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.panel.hidden = false;
          this.error.textContent = this.dataset.loadingMessage;
          this.error.hidden = false;
          return;
        }
        if (this.selected && !this.first.value.trim()) {
          this.first.value = '';
          event.preventDefault();
          event.stopImmediatePropagation();
          this.first.reportValidity();
          return;
        }
        this.pending = this.reference;
      }

      onCartUpdate(event) {
        const data = event.detail?.data;
        if (!this.pending || data?.source !== 'product-form-component' || String(data.productId) !== this.dataset.productId) return;
        if (event.target !== this.form?.closest('product-form-component')) return;
        if (data.didError) {
          this.pending = null;
          return;
        }
        if (this.pending !== this.reference) return;
        this.pending = null;
        this.reference = this.newReference();
        this.first.value = '';
        this.second.value = this.dataset.defaultLineTwo;
        this.sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
